import { getCookie, setCookie } from './storage'

export const getHypertuneUserId = (): string | null => {
  return getCookie('hypertune_user_id')
}

export const setHypertuneUserId = (userId: string): void => {
  setCookie('hypertune_user_id', userId, {
    expires: 365,
    path: '/',
  })
}

export const getHypertuneContext = (): { userId: string | null } => {
  if (typeof window === 'undefined') {
    // Server-side
    return {
      userId: getHypertuneUserId(),
    }
  } else {
    // Client-side
    return {
      userId: getHypertuneUserId(),
    }
  }
}
